module.exports = __webpack_public_path__ + "img/img36.58147a28.svg";